import { ErrorBoundary } from 'react-error-boundary';

import styles from './MicroFrontend.module.scss';
import { MicroFrontendBootstraper } from './internals/MicroFrontendBootstraper';
import { MicroFrontendIframeBootstraper } from './internals/MicroFrontendIframeBootstraper';

export function MicroFrontend({
  mode,
  ...props
}: {
  moduleName: string;
  mode: 'direct' | 'iframe';
  [key: string]: any;
}) {
  return (
    <ErrorBoundary
      key={props.moduleName}
      FallbackComponent={MicroFrontendErrorFallback}
    >
      {mode === 'iframe' ? (
        <MicroFrontendIframeBootstraper {...props} />
      ) : (
        <MicroFrontendBootstraper {...props} />
      )}
    </ErrorBoundary>
  );
}

function MicroFrontendErrorFallback({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return (
    <div role="alert" className={styles.errorFallback}>
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}
